import { Component, EventEmitter, HostListener, Input,
  OnInit, Output, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { environment } from 'environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';


@Component({
    selector: 'app-popup-container',
    templateUrl: './popup-container.component.html',
    styleUrls: ['./popup-container.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PopupContainerComponent implements OnInit {
  private _visible = false;
  private _width: number | string = 'auto';
  private _height: number | string = 'auto';
  private _title!: string;

  @Input()
  get visible(): boolean {
    return this._visible;
  }

  set visible(value: boolean) {
    this._visible = value;
    this.visibleChange.emit(value);
  }

  @Input()
  get width(): number | string {
    return this._width;
  }

  set width(value: number | string) {
    this._width = value;
    this.widthChange.emit(value);
  }

  @Input()
  get height(): number | string {
    return this._height;
  }

  set height(value: number | string) {
    this._height = value;
    this.heightChange.emit(value);
  }

  @Input()
  get title(): string {
    return this._title;
  }

  set title(value: string) {
    this._title = value;
    this.titleChange.emit(value);
  }

  @Input() fullScreenOnMobile = true;
  @Input() fullScreenOnTablet = false;
  @Input() fullScreen = false;
  @Input() fullWidthOnMobile = false;
  @Input() autoFullScreenOnOverflow = true;
  @Input() showCloseButton = true;
  @Input() shading = true;
  @Input() dragEnabled = false;
  @Input() showTitle = true;
  @Input() isFixedHeight = true;
  @Input() paddingContentWrapper = true;
  @Input() closeTabIndex!: number;

  // skipcq: JS-0323
  @Input() footerTemplate!: TemplateRef<any>;
  // skipcq: JS-0323
  @Input() headerTemplate!: TemplateRef<any>;

  @Output() readonly visibleChange = new EventEmitter();
  @Output() readonly widthChange = new EventEmitter();
  @Output() readonly heightChange = new EventEmitter();
  @Output() readonly titleChange = new EventEmitter();
  @Output() readonly onShowed = new EventEmitter();
  // skipcq: JS-0323
  @Output() readonly onHiding = new EventEmitter<any>();
  @Output() readonly popupShowing = new EventEmitter();

  isDelayContent = false;

  get widthStr(): string {
    if (this._width === 'auto') return 'auto';
    return typeof this._width === 'number' ? this._width + 'px' : String(this._width);
  }

  get heightStr(): string | null {
    if (this._height === 'auto') return null;
    return typeof this._height === 'number' ? this._height + 'px' : String(this._height);
  }

  isAppleDevice = false;
  isFullScreenPopup = false;
  autoContentContainerHeight = true;

  environment = environment;

  constructor(private deviceService: DeviceDetectorService) {
  }

  ngOnInit() {
    this.isAppleDevice = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);

    if (this.fullScreen) {
      this.isDelayContent = true;
    }

    this.popupInit();
  }

  popupInit() {
    if (this.height !== 'auto') {
      this.autoContentContainerHeight = false;
    }

    if (this.fullScreen) {
      this.isFullScreenPopup = true;
    } else if (!this.fullScreen && this.fullScreenOnTablet) {
      this.isFullScreenPopup = this.deviceService.isTablet();
    } else if (!this.fullScreenOnTablet && this.fullScreenOnMobile) {
      this.isFullScreenPopup = this.deviceService.isMobile();
    }

    if (this.deviceService.isMobile() && this.fullWidthOnMobile) {
      this.width = '100%'
    }

    /**
     * Auto Fullscreen in case width/maxWidth greater than the window
     */
    if (this.autoFullScreenOnOverflow) {
      if (this.width !== 'auto' && (this.width as number) >= window.innerWidth) {
        this.isFullScreenPopup = true;
      }
    }
  }

  @HostListener('window:resize')
  onResize() {
    setTimeout(() => {
      this.popupInit();
    }, 300);
  }

  onPopupHidden() {
    this.visible = false;
  }

  // skipcq: JS-0323
  onPopupHiding(e: any) {
    this.onHiding.emit(e);
  }
}
